import i18n from 'i18next';
import postProcessor from 'i18next-sprintf-postprocessor';
import { initReactI18next } from 'react-i18next';
// import pako from 'pako';

import en from '../data/locale/en.json';
import enCompany from '../data/locale/company/en.json';
import enCountries from '../data/locale/countries/en.json';
// import enCompanyPrivacy from '../data/locale/company/en.privacy.txt';
// import enCompanyLegal from '../data/locale/company/en.legal.txt';
// import enCompanyPrivacyCompressed from '../data/locale/company/en.privacy.txt.gz';
// import enCompanyLegalCompressed from '../data/locale/company/en.legal.txt.gz';
import { enLeg, enTime, enDistance } from './en';
import ru from '../data/locale/ru.json';
import ruCompany from '../data/locale/company/ru.json';
import ruCountries from '../data/locale/countries/ru.json';
// import ruCompanyPrivacy from '../data/locale/company/ru.privacy.txt';
import { ruLeg, ruTime, ruDistance } from './ru';

// const edCompanyPrivacyBin = new Uint8Array(enCompanyPrivacyCompressed);
// const enCompanyPrivacyData = pako.inflate(edCompanyPrivacyBin, { to: 'string' });
// const enCompanyPrivacy = String.fromCharCode.apply(null, new Uint16Array(enCompanyPrivacyData));
// // const enCompanyLegalBin = new Uint8Array(enCompanyLegalCompressed.split('').map((x) => x.charCodeAt(0)));
// // enCompanyLegalBin.set([65, 65, 65]);
// const enCompanyLegal = pako.inflate(enCompanyLegalCompressed, { to: 'string' });
// // const enCompanyLegal = pako.inflate(enCompanyLegalBin, { to: 'string' });
// // const enCompanyLegalData = pako.inflate(enCompanyLegalBin, { to: 'string' });
// // const enCompanyLegal = String.fromCharCode.apply(null, new Uint16Array(enCompanyLegalData));
// // enCompanyLegal = 'TEST';
// // enCompanyLegal = pako.inflate(enCompanyPrivacyCompressed);

let enCombined = en;
enCombined = Object.assign(enCombined, enCompany);
enCombined = Object.assign(enCombined, enCountries);
// enCombined.company_privacy = enCompanyPrivacy;
// enCombined.company_legal = enCompanyLegal;

let ruCombined = ru;
ruCombined = Object.assign(ruCombined, ruCompany);
ruCombined = Object.assign(ruCombined, ruCountries);
// ruCombined.company_privacy = enCompanyPrivacy;
// ruCombined.company_legal = enCompanyLegal;
ruCombined.company_privacy = enCombined.company_privacy;
ruCombined.company_legal = enCombined.company_legal;

const resources = {
  // TODO(clairbee): introduce lazy loading
  ru: { translation: ruCombined },
  en: { translation: enCombined },
};

const legResources = {
  ru: ruLeg,
  en: enLeg,
};

const timeResources = {
  ru: ruTime,
  en: enTime,
};

const distanceResources = {
  ru: ruDistance,
  en: enDistance,
};

const translate = (t, params) => i18n.t(t, params);
const translateLeg = (duration, distance) => legResources[i18n.language](duration, distance);
const translateTime = (duration) => timeResources[i18n.language](duration);
const translateDistance = (distance) => distanceResources[i18n.language](distance);

const setI18nConfig = () => {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(postProcessor)
    .init({
      resources,
      fallbackLng: 'en',

      keySeparator: false, // we do not use keys in form messages.welcome

      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });
};

export {
  translate,
  translateLeg,
  translateTime,
  translateDistance,
  setI18nConfig,
  i18n,
};
